import 'css-chunksrc/client/pages/exportsPage/wbsReport/styles.scss';export default {
  "wbsReport": "_wbsReport_1cv53_1",
  "checked": "_checked_1cv53_7",
  "row": "_row_1cv53_11",
  "checkbox": "_checkbox_1cv53_20",
  "col": "_col_1cv53_26",
  "name": "_name_1cv53_30",
  "description": "_description_1cv53_37",
  "filters": "_filters_1cv53_42",
  "button": "_button_1cv53_51"
};